var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5278 0H13.6944C13.4347 0 13.2222 0.213751 13.2222 0.475V18.525C13.2222 18.7863 13.4347 19 13.6944 19H16.5278C16.7875 19 17 18.7863 17 18.525V0.475C17 0.213751 16.7875 0 16.5278 0Z",
    fill: "#2C4D52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30556 0H0.472222C0.212501 0 0 0.213751 0 0.475V18.525C0 18.7863 0.212501 19 0.472222 19H3.30556C3.56528 19 3.77778 18.7863 3.77778 18.525V0.475C3.77778 0.213751 3.56528 0 3.30556 0Z",
    fill: "#2C4D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.aa6cb67cf200396976ba06c7c1260b85.svg";
export { ForwardRef as ReactComponent };